import {http} from "mam-core-react";
import {setHttpOptions} from "mam-core-react/dist/modules/http";

export {
    http,
    setHttpOptions
}